import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    accountApplyfields: []
  },
  mutations: {
    SET_ACCOUNT_APPLYFIELDS (store, items) {
      store.accounts.selectIds = items
    }
  },
  getters: {
    getAccountApplyfields: (store, getters) => {
      return store.accounts.accountApplyfields
    }
  },
  actions: {
    /*
    selectAccountApplyfields
    */
    selectAccountApplyfields ({commit, dispatch, getters, state}, filters) {
      return dispatch('getAccountApplyfields', filters).then((response) => {
        commit('SET_ACCOUNT_APPLYFIELDS', response)
        return response
      })
    },
    /*
    getAccountApplyfields
    */
    getAccountApplyfields ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${id}/account-applyfields`)
      .then((response) => {
        return response.data
      })
    },
    /*
    updateAccountApplyfields
    */
    updateAccountApplyfields ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${data._id}/account-applyfields`, data)
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.data
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/accountApplyfields.js